export default __webpack_public_path__ + "static/media/amigo.a84226a1.gif";